__turbopack_context__.v({
  "container": "low-balance-offer-plate-module-scss-module__vYtZSa__container",
  "failContainer": "low-balance-offer-plate-module-scss-module__vYtZSa__failContainer",
  "failFooter": "low-balance-offer-plate-module-scss-module__vYtZSa__failFooter",
  "failHeading": "low-balance-offer-plate-module-scss-module__vYtZSa__failHeading",
  "failIconWrap": "low-balance-offer-plate-module-scss-module__vYtZSa__failIconWrap",
  "failText": "low-balance-offer-plate-module-scss-module__vYtZSa__failText",
  "link": "low-balance-offer-plate-module-scss-module__vYtZSa__link",
  "offersWrapper": "low-balance-offer-plate-module-scss-module__vYtZSa__offersWrapper",
  "orDivider": "low-balance-offer-plate-module-scss-module__vYtZSa__orDivider",
  "primaryBtn": "low-balance-offer-plate-module-scss-module__vYtZSa__primaryBtn",
  "secondaryBtn": "low-balance-offer-plate-module-scss-module__vYtZSa__secondaryBtn",
  "text": "low-balance-offer-plate-module-scss-module__vYtZSa__text",
  "text_heading": "low-balance-offer-plate-module-scss-module__vYtZSa__text_heading",
});
